"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _EntityDetail = _interopRequireDefault(require("./components/EntityDetail"));

var _EntityList = _interopRequireDefault(require("./components/EntityList"));

var _default = function _default(_ref) {
  var entities = _ref.entities;
  var EntityDetail = (0, _EntityDetail.default)({
    entities
  });
  var EntityList = (0, _EntityList.default)({
    entities
  });
  return {
    EntityDetail,
    EntityList
  };
};

exports.default = _default;